import { HTMLProjectionNode } from '../../projection/node/HTMLProjectionNode.mjs';
import { MeasureLayout } from './layout/MeasureLayout.mjs';
var layout = {
  layout: {
    ProjectionNode: HTMLProjectionNode,
    MeasureLayout: MeasureLayout
  }
};
export { layout };